import { LlmImageStyle } from "@towersystems/roam-common/lib/generated-types";
import React from "react";

export const GenerateIconScreenContext = React.createContext<{
  onSubmit: (base64Image: string) => Promise<void>;
}>({
  onSubmit: () => Promise.resolve(),
});

export const iconStyles = [
  {
    key: LlmImageStyle.FLAT_DESIGN,
    label: "Flat Design",
    image: "",
  },
  {
    key: LlmImageStyle.GEOMETRIC_ABSTRACTION,
    label: "Geometric Abstraction",
    image: "",
  },
  {
    key: LlmImageStyle.MASCOT,
    label: "Mascot",
    image: "",
  },
  {
    key: LlmImageStyle.MOSAIC,
    label: "Mosaic",
    image: "",
  },
  {
    key: LlmImageStyle.NEON,
    label: "Neon",
    image: "",
  },
  {
    key: LlmImageStyle.OUTLINE,
    label: "Outline",
    image: "",
  },
  {
    key: LlmImageStyle.FILLED,
    label: "Filled",
    image: "",
  },
  {
    key: LlmImageStyle.PENCIL_SKETCH,
    label: "Pencil Sketch",
    image: "",
  },
  {
    key: LlmImageStyle.THREE_D,
    label: "3D",
    image: "",
  },
  {
    key: LlmImageStyle.ISOMETRIC,
    label: "Isometric",
    image: "",
  },
  {
    key: LlmImageStyle.PIXEL_ART,
    label: "Pixel Art",
    image: "",
  },
];
